// @flow
import React from 'react';
import { FinectIsoPlus } from '@finect/tabular-components/FinectIsoPlus';
import { PlusLogo } from '@finect/tabular-components/PlusLogo';
import { DateLabel } from '@finect/tabular-components/DateLabel';
import { Link } from '@finect/tabular-icons/link';
import { Video } from '@finect/tabular-components/Videos';
// import { EntityCard } from '@finect/tabular-components/EntityCard';
import { Image } from '@finect/tabular-components/Image';
import { Flex } from '../components/Flex';
import { Topic, Topics } from '../components/Topic';
import { Title6 } from '../components/Headings';
import { getArticlePreviewText } from '../../../utils/articles';
import { VideoContent, ArticleContent, ArticlePlusInfo, Small, External, PlusImage } from '../partials';
import { getCommonProps } from './utils';

const renderTags = (tags) => {
  // plus tags first
  const plusTags = tags.filter(tag => tag.id >= 50100 && tag.id <= 50110);
  const otherTags = tags.filter(tag => !(tag.id >= 50100 && tag.id <= 50110));

  return [...plusTags, ...otherTags].map((tag) => {
    const plus2 = tag.id >= 50100 && tag.id <= 50110;

    if (plus2) {
      return (
        <Topic title={tag.name} plus2={plus2} key={tag.id}>
          <FinectIsoPlus color="#fff" size={14} />
          <PlusLogo color="#fff" size={26} />
        </Topic>
      );
    }

    return (
      <Topic key={tag.id} plus href={`/temas/${tag.alias ? tag.alias : tag.url}`} title={tag.name} followed={true}>
        {tag.name}
      </Topic>
    );
  });
};

type Props = {
  article: Object,
  onSubscribe: Function,
  userSubscriptions: Object,
  userLikes: Object,
  withAuthor?: boolean,
  withText?: boolean
};

export const ArticlePlusListCard = ({
  article,
  withAuthor = true,
  userSubscriptions = {},
  withText = false
}: Props) => {
  const { title, date, externalUrl, externalPath, link, image, author, authorContent, tags, linkProps, video } =
    getCommonProps(article, userSubscriptions, true);

  const tagsContent = tags && tags.length > 0 ? <Topics>{renderTags(tags)}</Topics> : <div />;

  const maxPhone = typeof window !== 'undefined' ? window.innerWidth < 500 : false;
  return (
    <ArticleContent>
      <ArticlePlusInfo hasImage={Boolean(image)} hasVideo={Boolean(['video'].includes(article.type) && video)}>
        <div>
          {['video'].includes(article.type) && video ? (
            <VideoContent>
              <Video video={video} />
            </VideoContent>
          ) :
            image && (
              <PlusImage alt={title} href={link} {...linkProps}>
                <div className="overlay" />
                <Image alt={title} src={image} height={240} />
                <div className="tags-title-mobile">
                  {tagsContent}

                  <Title6 as="h3">
                    <a
                      href={article.type !== 'podcast' && externalUrl ? externalUrl : link}
                      title={title}
                      {...linkProps}
                    >
                      {title}
                    </a>
                  </Title6>
                </div>
              </PlusImage>
            )
          }
        </div>

        <div>
          <div className="tags-title-desktop">
            {tagsContent}

            <Title6 as="h3">
              <a href={article.type !== 'podcast' && externalUrl ? externalUrl : link} title={title} {...linkProps}>
                {title}
              </a>
            </Title6>
          </div>

          {withText && article.body.text && (
            <p>{getArticlePreviewText(article.body.text, title.length > 100 ? 100 : 160)}</p>
          )}

          <Flex align="center">
            {author && withAuthor && authorContent}
            <div className="date-external">
              {externalUrl && (
                <Small>
                  <External href={externalUrl} rel="nofollow" target="_blank">
                    <Link size="16" strokeWidth="2.2" />
                    <span>{externalPath ? externalPath[0] : ''}</span>
                  </External>
                </Small>
              )}
              <Small withLeftMargin={Boolean(author && withAuthor)}>
                <DateLabel date={new Date(date)} format={maxPhone ? 'LL' : 'LLL'} />
              </Small>
            </div>
          </Flex>
        </div>
      </ArticlePlusInfo>
    </ArticleContent>
  );
};
